import React, { createContext, useContext, useState, useCallback } from 'react';
import { Snackbar, Alert } from '@mui/material';

const SnackbarContext = createContext(null);

export const useSnackbar = () => {
  const ctx = useContext(SnackbarContext);
  if (!ctx) throw new Error('useSnackbar must be used within SnackbarProvider');
  return ctx;
};

export const SnackbarProvider = ({ children }) => {
  const [snacks, setSnacks] = useState([]);

  const showSnack = useCallback((message, severity = 'info') => {
    const id = Date.now() + Math.random();
    setSnacks(prev => [...prev.slice(-2), { id, message, severity, open: true }]);
  }, []);

  const handleClose = useCallback((id) => {
    setSnacks(prev => prev.filter(s => s.id !== id));
  }, []);

  return (
    <SnackbarContext.Provider value={{ showSnack }}>
      {children}
      {snacks.map((snack, idx) => (
        <Snackbar
          key={snack.id}
          open={snack.open}
          autoHideDuration={snack.severity === 'error' ? null : snack.severity === 'warning' ? 6000 : 4000}
          onClose={() => handleClose(snack.id)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          style={{ bottom: 24 + idx * 72 }}
        >
          <Alert
            onClose={() => handleClose(snack.id)}
            severity={snack.severity}
            variant="filled"
            sx={{ minWidth: 300 }}
          >
            {snack.message}
          </Alert>
        </Snackbar>
      ))}
    </SnackbarContext.Provider>
  );
};
